import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Button } from "react-bootstrap";
import {
  fetchHygineFrequenciesData,
  fetchHygineStatsData,
} from "../../../../redux/hygiene-reducers/hygieneSlice";
import "../../../styles/../styles/../../styles/hydiene-system/hygine-tabs.css";
import FrequenecyTasks from "./FrequenecyTasks";
import { convertStraight } from "../../../common-data/Converts";
import CalendarLoader from "../../../common-components/CalendarLoader";
import { getTabTitle } from "./HygieneMocksData";
import TableSkeleton from "../../../common-components/TableSkeleton";

const HygineTaskOverview = ({
  isAdminPage,
  userInfoData,
  setMemberStatus,
  prevFilters,
  // taskDate,
  // gymID,
  registerApiCall,
}) => {
  const dispatch = useDispatch();
  const {
    hygineStatsLoading,
    hygineStatsError,
    hygineStats,
    hygineFrequenciesLoading,
    hygineFrequenciesError,
    hygineFrequencies,
  } = useSelector((state) => state.hygiene);

  const [selectedTab, setSelectedTab] = useState("all");

  const [allTaskStats, setAllTaskStats] = useState({});

  const [isPage, setIsPage] = useState(0);
  const [selectedFrequencyTab, setSelectedFrequencyTab] = useState("all");
  const [allTaskFrequencies, setAllTaskFrequencies] = useState([]);

  const tabKeys = Object.keys(allTaskStats);
  const idx = tabKeys.indexOf(selectedTab);
  const selectedTabIndex = idx === -1 ? 0 : idx;

  function onClearNumber() {
    setMemberStatus((prevs) => ({
      ...prevs,
      isShowTasksForm: false,
    }));
  }

  const handleTabSelect = (index) => {
    const selectedKey = Object.keys(allTaskStats)[index];
    setSelectedTab(selectedKey);
    setSelectedFrequencyTab("all");
    setIsPage(0);
  };

  const handleFrequencyTabSelect = (frequency_type) => {
    console.log(frequency_type);

    setSelectedFrequencyTab(frequency_type);
    setIsPage(0);
  };

  function getHygieneStats(prevFilters) {
    // if (isAdminPage || userInfoData?.gym_id) {
    // const statsFilters = {
    //   task_date: taskDate,
    //   gym_id: userInfoData?.gym_id || gymID || "",
    // };

    dispatch(
      fetchHygineStatsData({
        filters: prevFilters,
        token: userInfoData?.token,
      })
    );
    // }
  }

  function getHygieneFrequencies(prevFilters) {
    if (selectedTab) {
      const statsFilters = {
        // task_date: taskDate,
        // gym_id: userInfoData?.gym_id || gymID || "",
        ...prevFilters,
        status: selectedTab || "",
      };

      dispatch(
        fetchHygineFrequenciesData({
          filters: statsFilters,
          token: userInfoData?.token,
        })
      );
    }
  }

  useEffect(() => {
    getHygieneStats(prevFilters);
  }, [prevFilters]);

  useEffect(() => {
    getHygieneFrequencies(prevFilters);
  }, [selectedTab, prevFilters]);

  useEffect(() => {
    if (registerApiCall) {
      registerApiCall(() => getHygieneStats(prevFilters));
      registerApiCall(() => getHygieneFrequencies(prevFilters));
    }
  }, [registerApiCall]);

  useEffect(() => {
    if (
      !hygineStatsLoading &&
      !hygineStatsError &&
      hygineStats?.status &&
      hygineStats?.data
    ) {
      const sortOrder = [
        "all",
        "pending",
        "completed",
        "re_submitted",
        "approved",
        "rejected",
        "all_rejected",
      ];

      const allKeys = Object.keys(hygineStats.data);

      const additionalKeys = allKeys.filter((key) => !sortOrder.includes(key));

      const finalSortOrder = [...sortOrder, ...additionalKeys];

      const sortedData = allKeys
        .sort((a, b) => finalSortOrder.indexOf(a) - finalSortOrder.indexOf(b))
        .reduce((acc, key) => {
          acc[key] = hygineStats.data[key];
          return acc;
        }, {});

      setAllTaskStats(sortedData);
    } else {
      setAllTaskStats({});
    }
  }, [hygineStatsLoading, hygineStatsError, hygineStats]);

  useEffect(() => {
    if (
      !hygineFrequenciesLoading &&
      !hygineFrequenciesError &&
      hygineFrequencies?.status &&
      hygineFrequencies?.data
    ) {
      setAllTaskFrequencies(hygineFrequencies.data);
    } else {
      setAllTaskFrequencies([]);
    }
  }, [hygineFrequenciesLoading, hygineFrequenciesError, hygineFrequencies]);

  return (
    <>
      <div className={`hun-container${isAdminPage ? " hun-mt-30" : ""}`}>
        {!isAdminPage && (
          <div className="hun-date-line">
            <span className="hun-date-label">TASK DATE</span>
            <span className="hun-date-value">
              {/* {convertStraight(prevFilters?.task_date)} */}
              {convertStraight(prevFilters?.task_date_from || "")}
              {" TO "}
              {convertStraight(prevFilters?.task_date_to || "")}
            </span>
          </div>
        )}
        <Tabs onSelect={handleTabSelect} selectedIndex={selectedTabIndex}>
          <TabList className="hun-tab-list">
            {hygineStatsLoading ? (
              <CalendarLoader
                shiftsPerDay={1}
                className="weekly-roster-overview-grid"
              />
            ) : (
              Object.entries(allTaskStats).map(([key, value]) => (
                <Tab key={key} className="hun-tab">
                  <div className="hun-tab-card">
                    <span className="hun-tab-title">
                      {getTabTitle(key)}

                      {/* {key === "completed"
                        ? "Submitted"
                        : key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())} */}
                    </span>
                    <span className="hun-tab-count">{value}</span>
                  </div>
                </Tab>
              ))
            )}
          </TabList>

          {Object.keys(allTaskStats).map((key) => (
            <TabPanel key={key} className="hun-tab-panel">
              <div className="hun-sub-tab-container">
                {hygineFrequenciesLoading ? (
                  <CalendarLoader
                    className="weekly-roster-overview-grid box-shadow-none mb30"
                    daysCount={1}
                    shiftsPerDay={2}
                  />
                ) : (
                  <div className="hun-sub-tab-list">
                    {allTaskFrequencies.map(
                      ({ frequency_type, total_task }) => (
                        <button
                          type="button"
                          key={frequency_type}
                          className={`hun-sub-tab-btn${
                            selectedFrequencyTab === frequency_type
                              ? " hun-active"
                              : ""
                          }`}
                          onClick={() =>
                            handleFrequencyTabSelect(frequency_type)
                          }
                        >
                          <span className="hun-sub-tab-title">
                            {frequency_type
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </span>
                          <span className="hun-sub-tab-count">
                            {total_task}
                          </span>
                        </button>
                      )
                    )}
                  </div>
                )}

                <div className="hun-sub-tab-panel">
                  {hygineFrequenciesLoading ? (
                    <TableSkeleton />
                  ) : (
                    allTaskFrequencies.map(
                      ({ frequency_type }) =>
                        selectedFrequencyTab === frequency_type && (
                          <FrequenecyTasks
                            key={frequency_type}
                            userInfoData={userInfoData}
                            selectedTab={selectedTab}
                            selectedFrequencyTab={selectedFrequencyTab}
                            isPage={isPage}
                            setIsPage={setIsPage}
                            callFunction={() => {
                              getHygieneStats(prevFilters);
                              getHygieneFrequencies(prevFilters);
                            }}
                            prevFilters={prevFilters}
                            // taskDate={taskDate}
                            // gymID={gymID}
                          />
                        )
                    )
                  )}
                </div>
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>

      {!isAdminPage && (
        <div className="hun-btn-container">
          <Button
            type="button"
            className="hun-back-btn"
            variant="dark"
            onClick={onClearNumber}
          >
            ← back
          </Button>
        </div>
      )}
    </>
  );
};

export default HygineTaskOverview;
